// extracted by mini-css-extract-plugin
export const container = "layout-module--container--3nGj0";
export const content = "layout-module--content--bviAP";